import { Routes } from '@angular/router';
import { userResolver } from './infrastructure/resolvers/user.resolver';
import { authGuard } from './infrastructure/guards/auth.guard';
import { deepLinkGuard } from './infrastructure/guards/deep-link.guard';

export const routes: Routes = [
    { path: '', redirectTo: 'registration', pathMatch: 'full' },
    {
        path: 'registration',
        loadComponent: () => import('./features/registration/ui/pages/registration/registration.component').then((c) => c.RegistrationComponent),
        loadChildren: () => import('./features/registration/registration-routes').then((routes) => routes.registrationRoutes),
    },
    {
        path: 'login',
        loadComponent: () => import('./features/authentication/ui/pages/authentication/authentication.component').then((c) => c.AuthenticationComponent),
        loadChildren: () => import('./features/authentication/authentication-routes').then((routes) => routes.authenticationRoutes),
    },
    {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/ui/pages/dashboard.component').then((c) => c.DashboardComponent),
        loadChildren: () => import('./features/dashboard/dashboard-routes').then((routes) => routes.DashboardRoutes),
        canMatch: [authGuard],
        resolve: { user: userResolver },
    },
    {
        path: 'activity',
        loadComponent: () => import('./features/activity/ui/pages/activity/activity.component').then((c) => c.ActivityComponent),
        loadChildren: () => import('./features/activity/activity-routes').then((routes) => routes.activityRoutes),
        canMatch: [deepLinkGuard,authGuard ],
        resolve: { user: userResolver },
    },
    {
        path: 'wallet',
        loadComponent: () => import('./features/wallet/ui/pages/wallet/wallet.component').then((c) => c.WalletComponent),
        loadChildren: () => import('./features/wallet/wallet-routes').then((routes) => routes.walletRoutes),
        canMatch: [deepLinkGuard,authGuard ],
        resolve: { user: userResolver },
    },
    {
        path: 'address-book',
        loadComponent: () => import('./features/address-book/ui/pages/address-book/address-book.component').then((c) => c.AddressBookComponent),
        loadChildren: () => import('./features/address-book/address-book-routes').then((routes) => routes.addressBookRoutes),
        canMatch: [deepLinkGuard,authGuard ],
        resolve: { user: userResolver },
    },
    {
        path: 'vehicles',
        loadComponent: () => import('./features/vehicles/ui/pages/vehicles/vehicles.component').then((c) => c.VehiclesComponent),
        loadChildren: () => import('./features/vehicles/vehicles-routes').then((routes) => routes.vehiclesRoutes),
        canMatch: [deepLinkGuard,authGuard ],
        resolve: { user: userResolver },
    },
    {
        path: 'profile',
        loadComponent: () => import('./features/profile/ui/pages/profile/profile.component').then((c) => c.ProfileComponent),
        loadChildren: () => import('./features/profile/profile-routes').then((routes) => routes.ProfileRoutes),
        canMatch: [deepLinkGuard,authGuard ],
        resolve: { user: userResolver },
    },
    {
        path: 'legal',
        loadComponent: () => import('./features/legal/ui/pages/legal/legal.component').then((c) => c.LegalComponent),
        loadChildren: () => import('./features/legal/legal-routes').then((routes) => routes.LegalRoutes),
        canMatch: [authGuard],
        resolve: { user: userResolver },
    },
];
